import { PageHero } from "@/components/Section";
import CTAButton from "@/components/CTAButton";

export default function NotFoundPage() {
  return (
    <>
      <PageHero
        eyebrow="404"
        title="That page is not on the menu."
        intro="The page you were looking for has moved or does not exist. Here are the useful places to go instead."
      >
        <div className="flex flex-wrap gap-3">
          <CTAButton to="/" data-testid="notfound-home">
            Back to home
          </CTAButton>
          <CTAButton to="/meals" variant="outline" data-testid="notfound-menu">
            View our meals
          </CTAButton>
        </div>
      </PageHero>
    </>
  );
}
